<template>
  <section class="product">
    <div
      class="image"
      :style="{ backgroundImage: image }"
      @click="show = true"
    ></div>

    <div v-if="show" class="backdrop" @click="show = false"></div>
    <transition name="showup">
      <div v-if="show" class="popup">
        <close-button class="close" @click="show = false"></close-button>
        <div class="image" :style="{ backgroundImage: image }"></div>
        <div>
          <h2>{{ product.name }}</h2>
          <ul>
            <li>
              <span class="title">Product</span
              >{{ product.printSpecification.title | capitalize }}
            </li>
            <li><span class="title">Aantal</span>{{ product.quantity }}</li>
            <li
              v-for="(value, name, index) in product.printSpecification"
              :key="index"
            >
              <span v-if="name != 'title'">
                <span class="title">{{ name }}</span
                >{{ value }}</span
              >
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  props: ['product'],
  data() {
    return {
      show: false
    }
  },
  methods: {
    toggle() {
      this.show = !this.show
    }
  },
  computed: {
    image() {
      let image = ''
      if (this.product.previewImage) {
        image = this.product.previewImage
      } else if (this.product.variant.previewImage) {
        image = this.product.variant.previewImage
      }

      return image
        ? `url(/media/print-store/${this.product.printStoreId}/preview/${image}/270)`
        : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  width: 135px;
  height: 135px;
  border-radius: 15px;
  padding: 15px;
  cursor: pointer;
  transition: box-shadow 0.5s ease-out;
  margin-bottom: 15px;
  position: relative;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.25) 0 0 20px -5px;
  }
}

.image {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: white;
  width: 100%;
  height: 100%;
}

.popup {
  width: 260px;
  background-color: white;
  z-index: 12;
  box-shadow: rgba(0, 0, 0, 0.25) 0 0 20px -5px;
  border-radius: 15px;
  padding: 30px;

  position: fixed;
  left: calc(50vw - 130px);
  top: calc(50vh - 190px);

  .image {
    width: 200px;
    height: 200px;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 18px;
    color: var(--sub-color);
    line-height: normal;
    padding-bottom: 6px;
  }

  li {
    padding-bottom: 6px;
  }

  .title {
    font-weight: 500;
    margin-right: 5px;
  }

  .close {
    position: absolute;
    top: 15px;
    right: 15px;
  }
}

.backdrop {
  background-color: transparent;
}

.showup-enter-active {
  animation: show-up 0.35s;
  animation-timing-function: ease-out;
}
.showup-leave-active {
  animation: show-up 0.35s reverse ease-out;
}
@keyframes show-up {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

@media only screen and (min-width: 620px) {
  .popup {
    position: absolute;
    top: -109px;
    left: -77px;
  }
}
</style>
